module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-100-inactive-bft-a31ae2fdf3e187bbdcedcb676ea6077f.png";